var trim = require('./trim');
var decap = require('./decapitalize');

module.exports = function camelize(str, decapitalize) {
  str = trim(str).replace(/[-_\s]+(.)?/g, function(match, c) {
    return c ? c.toUpperCase() : '';
  });

  if (decapitalize === true) {
    return decap(str);
  } else {
    return str;
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/underscore.string/camelize.js
 ** module id = 423
 ** module chunks = 0
 **/